import {
  Component,
  EventEmitter,
  forwardRef,
  Inject,
  OnInit,
  Output,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { NgAisInstantSearch } from 'angular-instantsearch';
import { FiltersService } from '@app/shared/components/catalog/services/filters.service';
import { connectToggle } from 'instantsearch.js/es/connectors';
import { CatalogWidgetDirective, IBaseItem } from '../catalog-widget';
import { ContentsMarketingFilter, Deal } from '@vestiaire/api-sdk-angular';

interface IToggleValue extends IBaseItem {
  onFacetValue?: IToggleValue;
  offFacetValue?: IToggleValue;
}

@Component({
  selector: 'vc-catalog-widget-toggle',
  templateUrl: './catalog-widget-toggle.component.html',
  styleUrls: ['./catalog-widget-toggle.component.scss', '../catalog-widgets.scss']
})
export class CatalogWidgetToggleComponent extends CatalogWidgetDirective implements OnInit, OnChanges {
  public seoUrl: string;

  state: {
    value: IToggleValue;
    createURL: () => string;
    refine: (value: IToggleValue) => void;
    widgetParams: {};
  };

  @Input()
  currentCountry: string;

  @Input()
  public isMobile: boolean;

  @Input()
  marketingFilterLocal: ContentsMarketingFilter;

  @Input()
  currentDeal: Deal;

  @Output()
  clickFilter = new EventEmitter<any>();

  @Output()
  refinedCountries: EventEmitter<any> = new EventEmitter<any>();

  private toggleValue: number | string = 1;

  public isDirectShipping: boolean;
  public isExpressDelivery: boolean;
  public isLocalCountries: boolean;
  public isdealsEligible: boolean;
  public sustainablePanelOpen = false;
  public dealsName = '';

  constructor(
    @Inject(forwardRef(() => NgAisInstantSearch)) public instantSearchParent,
    public filtersService: FiltersService
  ) {
    super('CatalogWidgetToggleComponent');
  }

  ngOnInit() {
    if (this.options.facet === 'dsEligibleCountries' || this.options.facet === 'localCountries') {
      this.toggleValue = this.currentCountry;
    }
    this.isdealsEligible = this.options.facet === 'editorPicks.dealEligible' || false;

    this.createWidget(connectToggle, {
      attributeName: this.options.facet,
      label: this.options.facet + '_on',
      values: { on: this.toggleValue, off: undefined }
    });

    this.isDirectShipping = this.options.label === 'CATALOG.FILTERS.DS';
    this.isExpressDelivery = this.options.label === 'DELIVERY_OPTS.EXPRESS';
    this.isLocalCountries = this.options.label === 'CATALOG.FILTERS.LOCAL_COUNTRIES';

    if (this.facetLink && this.facetLink.optionDelivery) {
      const f = this.facetLink.optionDelivery.find(facetLink => facetLink.facetId === this.options.facet);
      this.seoUrl = f && f.path;
    }

    super.ngOnInit();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.currentDeal && changes.currentDeal?.currentValue) {
      this.dealsName = changes.currentDeal?.currentValue?.localizedName || '';
    }
  }

  refineToggle(event: MouseEvent, item: IToggleValue) {
    event.preventDefault();
    event.stopPropagation();

    // refine through Algolia API
    this.state.refine(item);
    this.refined.emit(true);

    // refine country facet in the same time than localCountries
    if (this.isLocalCountries) {
      this.refinedCountries.emit(event);
    }

    // dispatch APPLY_FILTER action to send analytics
    if (!item.onFacetValue.isRefined) {
      this.clickFilter.emit({ filterItem: item, filterOptions: this.options });
    }
  }
}
